import { IsString, MaxLength } from 'class-validator';

export class TenantSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
